<script>
export default {
  name: 'Panel',
}
</script>

<script setup>
import { NodeViewWrapper, nodeViewProps, NodeViewContent } from "@tiptap/vue-3"
import EditableNode from "../../Components/EditableNodeWrapper.vue"
import useNodeProps from "@/Composables/useNodeProps"
import ToolbarButton from "@/Components/Inputs/BlockEditor/Extension/Components/ToolbarButton.vue"
import { QueueListIcon } from '@heroicons/vue/24/solid'

const props = defineProps({
  ...nodeViewProps,
})

let { topMargin } = useNodeProps(props)
</script>

<template>
  <node-view-wrapper>
    <EditableNode v-bind="props">
      <template #tools>
        <ToolbarButton :icon="QueueListIcon" label="Toggle Top Margin" v-model="topMargin" toggle/>
      </template>
      <template #content>
        <div class="bg-white shadow rounded p-4" :class="topMargin ? 'mt-6' : ''">
          <node-view-content></node-view-content>
        </div>
      </template>
    </EditableNode>
  </node-view-wrapper>
</template>
